import { render, staticRenderFns } from "./OctTable.vue?vue&type=template&id=20300ff7&scoped=true&"
import script from "./OctTable.vue?vue&type=script&lang=js&"
export * from "./OctTable.vue?vue&type=script&lang=js&"
import style0 from "./OctTable.vue?vue&type=style&index=0&id=20300ff7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20300ff7",
  null
  
)

export default component.exports